import { ROUTES, WEBVIEW_ROUTES } from 'constants/routes';
import lazyDelayedImport from 'utils/lazyDelayedImport';

export const protectedRoutes = [
  ...[
    ROUTES.MANAGED_BLOCKING,
    ROUTES.MANAGED_BLOCKING_SCHOOL,
    ROUTES.MANAGED_BLOCKING_CHILD
  ].map((path) => ({
    path,
    Component: lazyDelayedImport(() => import('pages/managed-blocking'))
  })),
  {
    index: true,
    Component: lazyDelayedImport(() => import('pages/home'))
  },
  {
    path: ROUTES.PROFILE,
    Component: lazyDelayedImport(() => import('pages/profile'))
  },
  {
    path: ROUTES.CHAT,
    Component: lazyDelayedImport(() => import('pages/chat-bot'))
  },
  {
    path: ROUTES.TEAM,
    Component: lazyDelayedImport(() => import('pages/team'))
  },
  {
    path: ROUTES.CLASS_SESSION_PLAYGROUND,
    Component: lazyDelayedImport(() => import('pages/class-session-playground'))
  },
  {
    path: ROUTES.CLASS,
    Component: lazyDelayedImport(() => import('pages/class'))
  },
  {
    path: ROUTES.FOCUS_LOGS,
    Component: lazyDelayedImport(() => import('pages/focus-logs'))
  },
  {
    path: ROUTES.SETTINGS,
    Component: lazyDelayedImport(() => import('pages/settings-revamp'))
  },
  {
    path: ROUTES.MARKETPLACE,
    Component: lazyDelayedImport(() => import('pages/marketplace'))
  },
  {
    path: ROUTES.HABIT_PACK_WELCOME,
    Component: lazyDelayedImport(
      () => import('pages/marketplace/PackWelcomePage')
    )
  },
  {
    path: ROUTES.FOCUS_TEMPLATE_WELCOME,
    Component: lazyDelayedImport(
      () => import('pages/marketplace/FocusTemplateWelcomePage')
    )
  },
  {
    path: ROUTES.LIBRARY,
    Component: lazyDelayedImport(() => import('pages/activity-library'))
  },
  {
    path: ROUTES.ADMIN,
    Component: lazyDelayedImport(() => import('pages/admin'))
  },
  // Temporarily disabled - needs major changes due to latest changes like custom routines
  // {
  //   path: ROUTES.ROUTINE_PLAYER,
  //   Component: lazyDelayedImport(() => import('pages/routinePlayer'))
  // },
  {
    path: ROUTES.MOTIVATIONAL_SUMMARY,
    Component: lazyDelayedImport(() => import('pages/motivation'))
  },
  {
    path: ROUTES.PROJECTS,
    Component: lazyDelayedImport(() => import('pages/projects/ProjectsLayout')),
    children: [
      {
        index: true,
        Component: lazyDelayedImport(() => import('pages/projects'))
      },
      {
        path: ':id',
        Component: lazyDelayedImport(
          () => import('pages/projects/ProjectsDetailPage')
        )
      }
    ]
  },
  {
    path: ROUTES.TODO,
    Component: lazyDelayedImport(() => import('pages/to-do'))
  },
  {
    path: ROUTES.DAY_PLAN,
    Component: lazyDelayedImport(() => import('pages/day-plan'))
  },
  {
    path: ROUTES.NOTES,
    Component: lazyDelayedImport(() => import('pages/notes'))
  },
  {
    path: ROUTES.PLATFORM_CALLBACK,
    Component: lazyDelayedImport(
      () => import('dashboard/to-do/integrations/IntegrationCallback')
    )
  },
  {
    path: ROUTES.MANAGE_SUBSCRIPTION,
    Component: lazyDelayedImport(() => import('pages/subscription'))
  },
  {
    path: ROUTES.ACCEPT_INVITE,
    Component: lazyDelayedImport(
      () => import('pages/team/TeamAcceptInvitation')
    )
  },
  {
    path: ROUTES.ACCEPT_PROJECT_INVITE,
    Component: lazyDelayedImport(
      () => import('pages/projects/AcceptProjectInvite')
    )
  },
  {
    path: ROUTES.ONBOARD_FLOW,
    Component: lazyDelayedImport(() => import('pages/onboard-flow'))
  },
  {
    path: ROUTES.MOBILE_APP_DOWNLOAD,
    Component: lazyDelayedImport(() => import('pages/mobile-app-download'))
  },
  {
    path: ROUTES.HABIT_PACK_SHARE,
    Component: lazyDelayedImport(
      () => import('pages/marketplace/PackLandingPage')
    )
  },
  {
    path: ROUTES.FOCUS_TEMPLATE_SHARE,
    Component: lazyDelayedImport(
      () => import('pages/marketplace/FocusTemplateLandingPage')
    )
  },
  {
    path: ROUTES.DESKTOP_REDIRECT,
    Component: lazyDelayedImport(
      () => import('pages/auth/desktop/DesktopRedirect')
    )
  },
  {
    path: ROUTES.INTEGRATIONS,
    Component: lazyDelayedImport(() => import('pages/integrations'))
  },
  {
    path: ROUTES.ACCOUNTABILITY_BUDDY_ACCEPT,
    Component: lazyDelayedImport(
      () => import('pages/accountability-buddy/AcceptInvitation')
    )
  },
  {
    path: ROUTES.ACCOUNTABILITY_BUDDY_APPROVE_UNLOCK,
    Component: lazyDelayedImport(
      () => import('pages/accountability-buddy/ApproveUnlockRequest')
    )
  },
  {
    path: ROUTES.ACCOUNTABILITY_BUDDY,
    Component: lazyDelayedImport(() => import('pages/accountability-buddy'))
  },
  {
    path: ROUTES.DOWNLOAD_APPS,
    Component: lazyDelayedImport(() => import('pages/download-apps'))
  }
];

export const publicRoutes = [
  {
    path: ROUTES.VERIFY_EMAIL,
    Component: lazyDelayedImport(
      () => import('pages/public/auth/EmailVerification')
    )
  },
  {
    path: ROUTES.RESET_PASSWORD,
    Component: lazyDelayedImport(
      () => import('pages/public/auth/ResetPassword')
    )
  },
  {
    path: ROUTES.VIEW_AUDHD_RESULTS,
    Component: lazyDelayedImport(
      () => import('pages/public/audhd-results-fallback')
    )
  },
  {
    path: ROUTES.SUPPORT_PANEL,
    Component: lazyDelayedImport(() => import('pages/support-panel'))
  }
];

export const webviewRoutes = [
  {
    path: WEBVIEW_ROUTES.WEBVIEW_MARKETPLACE,
    Component: import('pages/marketplace')
  },
  {
    path: WEBVIEW_ROUTES.WEBVIEW_CHAT,
    Component: import('pages/chat-bot')
  },
  {
    path: WEBVIEW_ROUTES.WEBVIEW_STATS,
    Component: import('pages/stats')
  },
  {
    path: WEBVIEW_ROUTES.WEBVIEW_MOTIVATIONAL_SUMMARY,
    Component: import('pages/stats')
  },
  {
    path: WEBVIEW_ROUTES.WEBVIEW_TODO_LIST,
    Component: import('pages/to-do/WebviewTodoList')
  },
  {
    path: `${WEBVIEW_ROUTES.WEBVIEW_PROJECT_DETAIL}/:id`,
    Component: import('pages/projects/ProjectsDetailPage'),
    matchPattern: true
  },
  {
    path: WEBVIEW_ROUTES.WEBVIEW_TOOLS_TODO_LIST,
    Component: import('pages/to-do/WebviewTodoList')
  },
  {
    path: WEBVIEW_ROUTES.WEBVIEW_SURVEY,
    Component: import('pages/survey')
  },
  {
    path: WEBVIEW_ROUTES.WEBVIEW_FOCUS_END,
    Component: import('pages/to-do/toDoFocusEnd')
  },
  {
    path: WEBVIEW_ROUTES.WEBVIEW_TO_DO_PLAYER,
    Component: import('pages/to-do/todo-player')
  },
  {
    path: WEBVIEW_ROUTES.WEBVIEW_MANAGE_SUBSCRIPTION,
    Component: import('pages/subscription')
  },
  {
    path: WEBVIEW_ROUTES.WEBVIEW_ROUTINE_SUGGESTION,
    Component: import('pages/routine-suggestions')
  },
  {
    path: WEBVIEW_ROUTES.WEBVIEW_ROUTINE_SUGGESTION_REVAMP,
    Component: import('pages/routine-suggestions-revamp')
  },
  {
    path: WEBVIEW_ROUTES.WEBVIEW_ENROLLED_COURSES,
    Component: import('pages/course/Tutorials')
  },
  {
    path: WEBVIEW_ROUTES.WEBVIEW_COURSE,
    Component: import('pages/course')
  },
  {
    path: WEBVIEW_ROUTES.WEBVIEW_GET_SUPPORT,
    Component: import('pages/get-support')
  },
  {
    path: WEBVIEW_ROUTES.WEBVIEW_SETTINGS,
    Component: import('pages/settings-revamp')
  },
  {
    path: WEBVIEW_ROUTES.WEBVIEW_NOTES,
    Component: import('pages/webview/notes')
  }
];
